import { render, staticRenderFns } from "./PartnerCreateQuery.vue?vue&type=template&id=72dfef32&scoped=true&"
import script from "./PartnerCreateQuery.vue?vue&type=script&lang=js&"
export * from "./PartnerCreateQuery.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72dfef32",
  null
  
)

export default component.exports